import { connect } from 'react-redux';
import { getMaxPrice } from '../redux/shared/selectors';
import { dollarsToPoints } from '../utils/points';
var mapStateToProps = function (state, ownProps) { return ({
    maxValue: ownProps.maxValue || dollarsToPoints(getMaxPrice(state)),
}); };
var mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=PointsInput.container.js.map